module.exports = "<div class=form-field> <div ng-if=!$ctrl.hideLabel ng-class=[$ctrl.labelClass] class=form-field-label> {{ $ctrl.label }} </div> <div ng-class=[$ctrl.valueClass] class=form-field-input> <div ng-if=!$ctrl.lookupList> {{ $ctrl.value }} </div> <div ng-if=$ctrl.lookupList> <span ng-repeat=\"item in $ctrl.lookupList\"> {{ item[$ctrl.lookupProp] }}<span ng-show=!$last>,</span> </span> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/form-fields/display-only-field/display-only-field.html
// module id = 343
// module chunks = 0